import React from "react";
import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { motion } from "framer-motion"
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation, Keyboard } from 'swiper/modules';
import { Parallax, useParallax } from 'react-scroll-parallax';
import '../assets/css/team-slider.css';
import '../assets/css/services-slider.css';
import { Link } from "react-router-dom";
import ContactSection from "../components/ContactSection";

const Home = () => {

  const [selectedIndustry, setSelectedIndustry] = useState("All");
  const [selectedService, setSelectedService] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const blogPosts = [
    {
      id: 1,
      title: "How to Create an Intranet Site Using SharePoint for Your Business",
      image: "https://www.q3tech.com/wp-content/uploads/2025/11/Intranet-Site-Using-SharePoint.jpg",
      date: "Dec 15, 2024",
      industry: "All",
      service: "Web Development",
      excerpt: "Learn how to leverage SharePoint to build a powerful intranet solution that enhances collaboration and productivity in your organization."
    },
    {
      id: 2,
      title: "AI Agent Use Cases: Real-World Applications Revolutionizing Business Operations",
      image: "https://www.q3tech.com/wp-content/uploads/2025/11/AI-Agent-Use-Cases.jpg", date: "Dec 10, 2024",
      industry: "All",
      service: "AI & ML",
      excerpt: "Discover how AI agents are transforming business operations across industries with real-world applications and use cases."
    },
    {
      id: 3,
      title: "SharePoint Corporate Intranet Portal Features for Modern Enterprises",
      image: "https://www.q3tech.com/wp-content/uploads/2025/11/SharePoint-Corporate-Intranet-Portal.jpg",
      date: "Dec 5, 2024",
      industry: "Finance",
      service: "Cloud Services",
      excerpt: "Explore the essential features of SharePoint corporate intranet portals that drive digital transformation in modern enterprises."
    },

  ];

  const allPartners = [
    { name: 'Cisco', logo: require('../assets/images/partner/Cisco.png') },
    { name: 'Dell', logo: require('../assets/images/partner/Dell_Logo.png') },
    { name: 'HPE', logo: require('../assets/images/partner/Hewlett_Packard_Enterprise_logo.svg.png') },
    { name: 'Microsoft', logo: require('../assets/images/partner/Microsoft.png') },
    { name: 'IBM', logo: require('../assets/images/partner/ibm.webp') },
    { name: 'Lenovo', logo: require('../assets/images/partner/lonovo.png') },
    { name: 'Oracle', logo: require('../assets/images/partner/Oracle.png') },
    { name: 'Salesforce', logo: require('../assets/images/partner/Salesforce.png') },
    { name: 'AWS', logo: require('../assets/images/partner/Amazon Web Services.png') },
    { name: 'VMware', logo: require('../assets/images/partner/vmware.jpeg') },
    { name: 'Red Hat', logo: require('../assets/images/partner/redhat.jpeg') },
    { name: 'Barracuda', logo: require('../assets/images/partner/Barracuda.png') },
    { name: 'Juniper Networks', logo: require('../assets/images/partner/Juniper Networks.png') },
    { name: 'SonicWall', logo: require('../assets/images/partner/SonicWall.webp') },
    { name: 'Adobe', logo: require('../assets/images/partner/Adobe.png') },
    { name: 'AutoCAD', logo: require('../assets/images/partner/AutoCAD.png') },
    { name: 'Acronis', logo: require('../assets/images/partner/Acronis.png') },
    { name: 'Linux', logo: require('../assets/images/partner/linux.jpeg') },
    { name: 'SUSE', logo: require('../assets/images/partner/suse.jpeg') },
    { name: 'Citrix', logo: require('../assets/images/partner/citrix.jpeg') },
    { name: 'Super Micro', logo: require('../assets/images/partner/Super Micro.jpg') },
    { name: 'Yotta', logo: require('../assets/images/partner/Yotta.jpg') },
    { name: 'Parent', logo: require('../assets/images/partner/Parent-logo.webp') },
  ];

  const filteredBlogs = blogPosts.filter(blog => {
    const matchesIndustry = selectedIndustry === "All" || blog.industry === selectedIndustry;
    const matchesService = selectedService === "All" || blog.service === selectedService;
    const matchesSearch = blog.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      blog.excerpt.toLowerCase().includes(searchQuery.toLowerCase());

    return matchesIndustry && matchesService && matchesSearch;
  });

  const [active, setActive] = useState("marketing");


  return (
    <>

      {/* Hero Video Section */}
      <section className="banner-section hero-slider-section">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="video-background"
        >
          <source src={require('../assets/images/banner-video.mp4')} type="video/mp4" />
        </video>

        <div className="hero-slide-container" style={{ background: 'transparent' }}>
          <div className="hero-slide-overlay">
            <div className="container container--narrow">
              <div className="hero-slide-content">
                <div className="row">
                  <div className="col-md-12 col-xxl-12">
                    {/* <span className="hero-label">OUR PURPOSE</span> */}
                    <h1 className="hero-main-heading">
                      Driving Enterprise Growth<br />
                      Through IT Excellence
                    </h1>
                    <p className="hero-description" style={{ textAlign: 'center', color: '#ffffff' }}>
                      We help businesses modernize, secure, and scale through cloud, cybersecurity, and managed IT solutions.
                    </p>

                    <Link to="/contact" style={{ textDecoration: 'none' }}>
                      <button className="breadcrumb-btn">
                        <span>CONNECT NOW</span>
                        <span className="breadcrumb-arrow">
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </span>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction About Section */}
      <section className="corporate-about-section pb-5 position-relative" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container">
          {/* Stats Floating Bar */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true, margin: "-100px" }}
            className="stats-container bg-white rounded shadow p-4 mx-auto"
            style={{ marginTop: '-60px', position: 'relative', zIndex: 10, maxWidth: '1000px' }}
          >
            <div className="row text-center g-4 align-items-center">
              <div className="col-md-3 col-6 border-end-md stat-item">
                <h3 className="fw-bold display-5 mb-2 text-dark">15+</h3>
                <p className="text-secondary mb-0 fw-medium">Years in Business</p>
              </div>
              <div className="col-md-3 col-6 border-end-md stat-item">
                <h3 className="fw-bold display-5 mb-2 text-dark">1600+</h3>
                <p className="text-secondary mb-0 fw-medium">Projects Delivered</p>
              </div>
              <div className="col-md-3 col-6 border-end-md stat-item">
                <h3 className="fw-bold display-5 mb-2 text-dark">600+</h3>
                <p className="text-secondary mb-0 fw-medium">Client Relationships</p>
              </div>
              <div className="col-md-3 col-6 stat-item">
                <h3 className="fw-bold display-5 mb-2 text-dark">20+</h3>
                <p className="text-secondary mb-0 fw-medium">Countries Served</p>
              </div>
            </div>
            <style>{`
              @media (min-width: 768px) {
                .border-end-md { border-right: 1px solid #dee2e6; }
              }
            `}</style>
          </motion.div>

          {/* About Content */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="text-center mt-5 pt-md-4 mx-auto px-3"
            style={{ maxWidth: '950px' }}
          >
            <h2 className="fw-bold mb-4" style={{ color: '#1a202c', fontSize: 'clamp(2rem, 3vw, 2.75rem)', lineHeight: '1.3' }}>
              Driving Sustainable Business Growth Through Innovative IT Solutions and Digital Transformation Services
            </h2>
            <p className="text-secondary mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
              At Solaris Performance Consistency, we help businesses improve efficiency, optimize operations, and achieve sustainable growth through innovative technology and engineering solutions. With expertise in IT services, electrical engineering, mechanical engineering, and warehouse solutions, we deliver reliable, scalable, and cost-effective services tailored to business needs. Our focus on quality, consistency, and customer satisfaction enables organizations to grow with confidence and stay ahead in a competitive market.            </p>
            <Link to="/about" className="d-inline-flex align-items-center text-decoration-none fw-bold mt-2" style={{ color: '#2b6cb0', fontSize: '1.1rem', transition: 'all 0.3s ease' }} onMouseOver={(e) => e.target.style.color = '#1a365d'} onMouseOut={(e) => e.target.style.color = '#2b6cb0'}>
              Learn More About Us <span className="ms-2 fs-5">→</span>
            </Link>
          </motion.div>
        </div>
      </section>

      {/* Our Services Section */}
      <section className="services-section py-5" style={{ backgroundColor: '#ffffff' }}>
        <div className="container">
          <div className="text-center mb-5">
            <span className="services-label" style={{ border: '1px solid #e2e8f0', padding: '6px 16px', borderRadius: '20px', fontSize: '12px', fontWeight: '600', letterSpacing: '1px', textTransform: 'uppercase', color: '#4a5568' }}>OUR SERVICES</span>
            <h2 className="services-main-heading mt-3 mb-3 fw-bold" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', color: '#1a202c' }}>
              <span style={{ color: '#4299e1' }}>Secure, Scalable</span> Solutions
              <br />for Every IT Need
            </h2>
          </div>

          <div className="row g-4 mt-4">
            {/* Core Capabilities Image Panel */}
            <div className="col-lg-4">
              <motion.div
                className="core-capabilities-card h-100 rounded-4 overflow-hidden position-relative"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
                style={{
                  backgroundImage: `url(${require('../assets/images/software-development.jpg')})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  minHeight: '400px'
                }}
              >
                <div className="overlay position-absolute top-0 start-0 w-100 h-100" style={{ background: 'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 100%)' }}></div>
                <div className="content position-absolute top-0 start-0 w-100 h-100 p-4 d-flex flex-column text-white">
                  <h3 className="fw-bold mb-3" style={{ fontSize: '1.5rem' }}>Core Capabilities</h3>
                  <p style={{ fontSize: '1rem', lineHeight: '1.6', maxWidth: '90%' }}>
                    End-to-end technology capabilities built for performance, resilience, and enterprise governance.
                  </p>
                </div>
              </motion.div>
            </div>

            {/* Service Grid Panels */}
            <div className="col-lg-8">
              <div className="row g-0 h-100" style={{ border: '1px solid #e2e8f0', borderRadius: '1rem', overflow: 'hidden' }}>

                {/* Service Item 1 */}
                <div className="col-md-6 border-bottom border-end">
                  <motion.div
                    className="service-item p-4 h-100 bg-white"
                    whileHover={{ backgroundColor: '#f8fafc', transition: { duration: 0.2 } }}
                  >
                    <h4 className="fw-semibold mb-3 fs-5" style={{ color: '#2d3748' }}>Professional Services</h4>
                    <p className="mb-4" style={{ color: '#718096', fontSize: '0.95rem', lineHeight: '1.6' }}>
                      Hybrid, on-premise, & modern workplace infrastructure designed to enhance reliability, performance, and scale.
                    </p>
                    <Link to="/services/professional-services" className="know-more-link text-decoration-none d-inline-flex align-items-center fw-medium" style={{ color: '#3182ce', fontSize: '0.9rem' }}>
                      Know More <span className="ms-1">→</span>
                    </Link>
                  </motion.div>
                </div>

                {/* Service Item 2 */}
                <div className="col-md-6 border-bottom">
                  <motion.div
                    className="service-item p-4 h-100 bg-white"
                    whileHover={{ backgroundColor: '#f8fafc', transition: { duration: 0.2 } }}
                  >
                    <h4 className="fw-semibold mb-3 fs-5" style={{ color: '#2d3748' }}>Data Center</h4>
                    <p className="mb-4" style={{ color: '#718096', fontSize: '0.95rem', lineHeight: '1.6' }}>
                      Modern data center solutions enabling high availability, scalability, and performance across hybrid environments.
                    </p>
                    <Link to="/services/data-center" className="know-more-link text-decoration-none d-inline-flex align-items-center fw-medium" style={{ color: '#3182ce', fontSize: '0.9rem' }}>
                      Know More <span className="ms-1">→</span>
                    </Link>
                  </motion.div>
                </div>

                {/* Service Item 3 */}
                <div className="col-md-6 border-bottom border-end">
                  <motion.div
                    className="service-item p-4 h-100 bg-white"
                    whileHover={{ backgroundColor: '#f8fafc', transition: { duration: 0.2 } }}
                  >
                    <h4 className="fw-semibold mb-3 fs-5" style={{ color: '#2d3748' }}>Cyber Security</h4>
                    <p className="mb-4" style={{ color: '#718096', fontSize: '0.95rem', lineHeight: '1.6' }}>
                      Zero Trust, SOC readiness, identity & access management, and ransomware protection.
                    </p>
                    <Link to="/services/cyber-security" className="know-more-link text-decoration-none d-inline-flex align-items-center fw-medium" style={{ color: '#3182ce', fontSize: '0.9rem' }}>
                      Know More <span className="ms-1">→</span>
                    </Link>
                  </motion.div>
                </div>

                {/* Service Item 4 */}
                <div className="col-md-6 border-bottom">
                  <motion.div
                    className="service-item p-4 h-100 bg-white"
                    whileHover={{ backgroundColor: '#f8fafc', transition: { duration: 0.2 } }}
                  >
                    <h4 className="fw-semibold mb-3 fs-5" style={{ color: '#2d3748' }}>Collaboration Services</h4>
                    <p className="mb-4" style={{ color: '#718096', fontSize: '0.95rem', lineHeight: '1.6' }}>
                      Modern collaboration solutions enabling seamless communication, productivity, and connected workforce experiences.
                    </p>
                    <Link to="/services/collaboration-services" className="know-more-link text-decoration-none d-inline-flex align-items-center fw-medium" style={{ color: '#3182ce', fontSize: '0.9rem' }}>
                      Know More <span className="ms-1">→</span>
                    </Link>
                  </motion.div>
                </div>

                {/* Service Item 5 */}
                <div className="col-md-6 border-end">
                  <motion.div
                    className="service-item p-4 h-100 bg-white rounded-bottom-start"
                    whileHover={{ backgroundColor: '#f8fafc', transition: { duration: 0.2 } }}
                  >
                    <h4 className="fw-semibold mb-3 fs-5" style={{ color: '#2d3748' }}>Managed Services</h4>
                    <p className="mb-4" style={{ color: '#718096', fontSize: '0.95rem', lineHeight: '1.6' }}>
                      24/7 monitoring, proactive support, and managed operations ensuring reliability, continuity, and optimized performance.
                    </p>
                    <Link to="/services/managed-services" className="know-more-link text-decoration-none d-inline-flex align-items-center fw-medium" style={{ color: '#3182ce', fontSize: '0.9rem' }}>
                      Know More <span className="ms-1">→</span>
                    </Link>
                  </motion.div>
                </div>

                {/* Service Item 6 */}
                <div className="col-md-6">
                  <motion.div
                    className="service-item p-4 h-100 bg-white rounded-bottom-end"
                    whileHover={{ backgroundColor: '#f8fafc', transition: { duration: 0.2 } }}
                  >
                    <h4 className="fw-semibold mb-3 fs-5" style={{ color: '#2d3748' }}>Enterprise Networking</h4>
                    <p className="mb-4" style={{ color: '#718096', fontSize: '0.95rem', lineHeight: '1.6' }}>
                      Secure, scalable enterprise networking solutions enabling high-performance connectivity across hybrid and multi-cloud environments.
                    </p>
                    <Link to="/services/enterprise-networking" className="know-more-link text-decoration-none d-inline-flex align-items-center fw-medium" style={{ color: '#3182ce', fontSize: '0.9rem' }}>
                      Know More <span className="ms-1">→</span>
                    </Link>
                  </motion.div>
                </div>

              </div>
            </div>

          </div>
        </div>
        <style>{`
          @media (max-width: 767.98px) {
            .service-item.border-end {
              border-right: none !important;
            }
          }
          .know-more-link {
            transition: all 0.3s ease;
          }
          .know-more-link:hover {
            color: #1a365d !important;
            transform: translateX(5px);
          }
          .know-more-link span {
            transition: transform 0.3s ease;
          }
          .know-more-link:hover span {
            transform: translateX(4px);
          }
        `}</style>
      </section>

      {/* We Are Solaris Section */}
      <section className="about-solaris-section position-relative py-5">
        {/* Background Image Box full width but nice height */}
        <div
          className="position-absolute top-0 start-0 w-100"
          style={{
            height: '100%',
            backgroundImage: `url('https://images.unsplash.com/photo-1542744173-8e7e53415bb0?q=80&w=2070&auto=format&fit=crop')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        ></div>

        {/* Dark Overlay similar to screenshot */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.65)' }}
        ></div>

        <div className="container position-relative py-5 my-md-4">
          <div className="row align-items-center">
            {/* Left large text */}
            <div className="col-lg-5 mb-5 mb-lg-0">
              <motion.h2
                className="fw-bold text-white mb-0"
                style={{ fontSize: 'clamp(3rem, 7vw, 5.5rem)', lineHeight: '1' }}
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
              >
                We Are<br />
                Solaris
              </motion.h2>
            </div>

            {/* Right content box */}
            <div className="col-lg-7 px-lg-4">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <p className="text-white mb-5" style={{ fontSize: '1.05rem', lineHeight: '1.8', opacity: 0.9 }}>
                  A global technology company specializing inCyber Security, Data Center Solutions, and Digital Infrastructure Services. We help organizations secure critical assets, optimize IT environments, and build resilient technology ecosystems. Through advanced cybersecurity strategies, secure data center management, cloud security, and enterprise infrastructure solutions, we enable businesses to strengthen protection, enhance performance, and achieve sustainable growth. Our expertise empowers organizations to reduce risks, ensure business continuity, and drive measurable operational impact.
                </p>
                {/* Metrics/Stats Row */}
                <div
                  className="d-flex flex-wrap gap-4 py-3 px-4 rounded-4"
                  style={{ border: '1px solid rgba(255, 255, 255, 0.2)', backgroundColor: 'rgba(255, 255, 255, 0.05)', backdropFilter: 'blur(10px)', display: 'inline-flex' }}
                >
                  <div className="pe-4 border-end border-light border-opacity-25" style={{ minWidth: '130px' }}>
                    <div className="text-white-50 mb-1" style={{ fontSize: '0.85rem' }}>Improve</div>
                    <div className="fw-semibold text-white fs-5">Efficiency</div>
                  </div>
                  <div className="px-4 border-end border-light border-opacity-25" style={{ minWidth: '130px' }}>
                    <div className="text-white-50 mb-1" style={{ fontSize: '0.85rem' }}>Enhance</div>
                    <div className="fw-semibold text-white fs-5">Revenues</div>
                  </div>
                  <div className="ps-4">
                    <div className="text-white-50 mb-1" style={{ fontSize: '0.85rem' }}>Elevate</div>
                    <div className="fw-semibold text-white fs-5">Experiences</div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Technology Partners Section */}
      <section className="trusted-clients-section py-5" style={{ backgroundColor: '#f8fafc' }}>
        <div className="container">
          <motion.div
            className="text-center mb-5"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="services-main-heading mt-3 mb-3 fw-bold" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', color: '#111827' }}>
              Our Trusted <span style={{ color: '#0ea5e9' }}>Clients</span>
            </h2>

          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <Swiper
              modules={[Autoplay]}
              spaceBetween={30}
              slidesPerView={2}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              speed={800}
              loop={true}
              breakpoints={{
                576: {
                  slidesPerView: 3,
                  spaceBetween: 30
                },
                768: {
                  slidesPerView: 4,
                  spaceBetween: 30
                },
                1024: {
                  slidesPerView: 5,
                  spaceBetween: 30
                },
                1200: {
                  slidesPerView: 6,
                  spaceBetween: 30
                }
              }}
              className="clients-logo-swiper px-2 py-4"
            >
              {[
                { src: require('../assets/images/solaris-client/client-1.webp'), alt: 'Cairn' },
                { src: require('../assets/images/solaris-client/client-2.png'), alt: 'BSA' },
                { src: require('../assets/images/solaris-client/client-34.png'), alt: 'STL' },
                { src: require('../assets/images/solaris-client/client-4.png'), alt: 'NTPC' },
                { src: require('../assets/images/solaris-client/client-5.png'), alt: 'Unicef' },
                { src: require('../assets/images/solaris-client/client-6.png'), alt: 'Client 6' },
                { src: require('../assets/images/solaris-client/client-7.png'), alt: 'Client 7' },
                { src: require('../assets/images/solaris-client/client-8.png'), alt: 'Client 8' },
                { src: process.env.PUBLIC_URL + '/client-9.svg', alt: 'Client 9' },
                { src: require('../assets/images/solaris-client/client-10.png'), alt: 'Client 10' },
                { src: require('../assets/images/solaris-client/HDFC-bank.webp'), alt: 'HDFC Bank' },
                { src: require('../assets/images/solaris-client/HPCL.jpg'), alt: 'HPCL' },
                { src: require('../assets/images/solaris-client/ICICI-Bank-Logo.jpg'), alt: 'ICICI Bank' },
                { src: process.env.PUBLIC_URL + '/IIT-rurkee.svg', alt: 'IIT Roorkee' },
                { src: require('../assets/images/solaris-client/IndianOilLogo.jpg'), alt: 'Indian Oil' },
                { src: require('../assets/images/solaris-client/JP Group.png'), alt: 'JP Group' },
                { src: require('../assets/images/solaris-client/NSDL_11zon.webp'), alt: 'NSDL' },
                { src: require('../assets/images/solaris-client/Patanjali Ayurveda.avif'), alt: 'Patanjali Ayurveda' },
                { src: require('../assets/images/solaris-client/Philips.png'), alt: 'Philips' },
                { src: require('../assets/images/solaris-client/Reliance.jpg'), alt: 'Reliance' },
                { src: require('../assets/images/solaris-client/U.P. Sugar.png'), alt: 'U.P. Sugar' },
                { src: require('../assets/images/solaris-client/Bluestar.png'), alt: 'Bluestar' },
                { src: require('../assets/images/solaris-client/bhu.png'), alt: 'BHU' },
                { src: require('../assets/images/solaris-client/kenra-bank.png'), alt: 'Kenra Bank' },
                { src: process.env.PUBLIC_URL + '/up-vidhan-sabha.svg', alt: 'UP Vidhan Sabha' },
              ].map((client, i) => (
                <SwiperSlide key={i}>
                  <motion.div
                    className="client-logo-wrapper bg-white rounded-4 d-flex align-items-center justify-content-center p-3"
                    style={{ height: '120px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03)', border: '1px solid #f1f5f9' }}
                    whileHover={{ y: -5, boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)', borderColor: '#e2e8f0' }}
                    transition={{ duration: 0.2 }}
                  >
                    <img
                      src={client.src}
                      alt={client.alt}
                      className="client-logo img-fluid"
                      style={{ maxHeight: '70px', objectFit: 'contain', transition: 'all 0.3s ease' }}
                    />
                  </motion.div>
                </SwiperSlide>
              ))}
            </Swiper>
          </motion.div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="testimonial-section py-5 position-relative overflow-hidden" style={{ background: '#0858a7' }}>
        <div className="container py-4">
          <motion.div
            className="text-center mb-5"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <span className="d-inline-block mb-3" style={{ color: '#ffffff', backgroundColor: 'rgba(255, 255, 255, 0.15)', padding: '6px 20px', borderRadius: '20px', fontSize: '12px', fontWeight: '500', letterSpacing: '1px', textTransform: 'uppercase' }}>
              OUR CLIENTS
            </span>
            <h2 className="fw-bold text-white mb-3" style={{ fontSize: 'clamp(2.5rem, 4vw, 3.5rem)', lineHeight: '1.2' }}>
              What Our Valuable Clients<br />Say About Us
            </h2>
            <p className="text-white opacity-90 mx-auto" style={{ fontSize: '1.1rem', maxWidth: '700px', lineHeight: '1.6' }}>
              Real outcomes delivered through reliable execution,<br />responsive support, and long-term partnership.
            </p>
          </motion.div>

          <Swiper
            modules={[Autoplay, Navigation, Pagination]}
            spaceBetween={24}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            autoplay={{
              delay: 3500,
              disableOnInteraction: false,
            }}
            breakpoints={{
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              }
            }}
            className="testimonial-swiper pb-5"
          >
            {/* Testimonial 1 */}
            <SwiperSlide>
              <motion.div
                className="testimonial-card p-4 h-100 rounded-4"
                style={{ backgroundColor: '#1e1b4b', minHeight: '380px', display: 'flex', flexDirection: 'column' }}
                whileHover={{ y: -5, boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2)' }}
                transition={{ duration: 0.3 }}
              >
                <div className="stars text-white mb-4 d-flex justify-content-center">
                  {'★'.repeat(5)}
                </div>
                <p className="text-white opacity-75 mb-4 text-center" style={{ fontSize: '0.95rem', lineHeight: '1.7', flexGrow: 1 }}>
                  We have collaborated with Solaris on multiple project requirements, and the overall experience has been consistently impressive. Their commitment, clarity in execution, and timely delivery make them a highly reliable technology partner organization.
                </p>
                <div className="author d-flex align-items-center mt-auto justify-content-center pt-3 border-top border-secondary border-opacity-25">
                  <div className="author-info text-start">
                    <h5 className="text-white mb-0 fs-6 fw-semibold">Neil Patwardhan</h5>
                    <span className="text-white opacity-50" style={{ fontSize: '0.8rem' }}>HDFC Bank</span>
                  </div>
                </div>
              </motion.div>
            </SwiperSlide>

            {/* Testimonial 2 */}
            <SwiperSlide>
              <motion.div
                className="testimonial-card p-4 h-100 rounded-4"
                style={{ backgroundColor: '#1e1b4b', minHeight: '380px', display: 'flex', flexDirection: 'column' }}
                whileHover={{ y: -5, boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2)' }}
                transition={{ duration: 0.3 }}
              >
                <div className="stars text-white mb-4 d-flex justify-content-center">
                  {'★'.repeat(5)}
                </div>
                <p className="text-white opacity-75 mb-4 text-center" style={{ fontSize: '0.95rem', lineHeight: '1.7', flexGrow: 1 }}>
                  We required an intelligent chatbot and personalization engine for our store, and they delivered far beyond expectations. Our conversions improved noticeably, support load reduced significantly, and their team proved to be an exceptional and dependable AI partner.
                </p>
                <div className="author d-flex align-items-center mt-auto justify-content-center pt-3 border-top border-secondary border-opacity-25">
                  <div className="author-info text-start">
                    <h5 className="text-white mb-0 fs-6 fw-semibold">Vivek Sinha</h5>
                    <span className="text-white opacity-50" style={{ fontSize: '0.8rem' }}>Reliance</span>
                  </div>
                </div>
              </motion.div>
            </SwiperSlide>

            {/* Testimonial 3 */}
            <SwiperSlide>
              <motion.div
                className="testimonial-card p-4 h-100 rounded-4"
                style={{ backgroundColor: '#1e1b4b', minHeight: '380px', display: 'flex', flexDirection: 'column' }}
                whileHover={{ y: -5, boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2)' }}
                transition={{ duration: 0.3 }}
              >
                <div className="stars text-white mb-4 d-flex justify-content-center">
                  {'★'.repeat(5)}
                </div>
                <p className="text-white opacity-75 mb-4 text-center" style={{ fontSize: '0.95rem', lineHeight: '1.7', flexGrow: 1 }}>
                  We shared only a raw idea with them, and within weeks they built an AI-powered prototype that impressed our investors. Their team understands startup urgency, moves fast, and consistently delivers high-quality work with clear communication.
                </p>
                <div className="author d-flex align-items-center mt-auto justify-content-center pt-3 border-top border-secondary border-opacity-25">
                  <div className="author-info text-start">
                    <h5 className="text-white mb-0 fs-6 fw-semibold">Ankit Kumar</h5>
                    <span className="text-white opacity-50" style={{ fontSize: '0.8rem' }}>Philips</span>
                  </div>
                </div>
              </motion.div>
            </SwiperSlide>

            {/* Testimonial 4 */}
            <SwiperSlide>
              <motion.div
                className="testimonial-card p-4 h-100 rounded-4"
                style={{ backgroundColor: '#1e1b4b', minHeight: '380px', display: 'flex', flexDirection: 'column' }}
                whileHover={{ y: -5, boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.2)' }}
                transition={{ duration: 0.3 }}
              >
                <div className="stars text-white mb-4 d-flex justify-content-center">
                  {'★'.repeat(5)}
                </div>
                <p className="text-white opacity-75 mb-4 text-center" style={{ fontSize: '0.95rem', lineHeight: '1.7', flexGrow: 1 }}>
                  I've collaborated with many AI vendors, but this team stands out for their speed, clarity, and strong technical expertise. They built a tailored machine-learning solution that streamlined our processes and delivered nearly a 30% improvement in overall efficiency.
                </p>
                <div className="author d-flex align-items-center mt-auto justify-content-center pt-3 border-top border-secondary border-opacity-25">
                  <div className="author-info text-start">
                    <h5 className="text-white mb-0 fs-6 fw-semibold">Jaisa James</h5>
                    <span className="text-white opacity-50" style={{ fontSize: '0.8rem' }}>NTPC</span>
                  </div>
                </div>
              </motion.div>
            </SwiperSlide>
          </Swiper>
        </div>
        <style>{`
          .testimonial-swiper .swiper-button-next,
          .testimonial-swiper .swiper-button-prev {
            color: rgba(255, 255, 255, 0.5);
            background: rgba(255, 255, 255, 0.1);
            width: 40px;
            height: 40px;
            border-radius: 50%;
            border: 1px solid rgba(255, 255, 255, 0.2);
            transition: all 0.3s ease;
          }
          .testimonial-swiper .swiper-button-next:after,
          .testimonial-swiper .swiper-button-prev:after {
            font-size: 16px;
          }
          .testimonial-swiper .swiper-button-next:hover,
          .testimonial-swiper .swiper-button-prev:hover {
            color: white;
            background: rgba(255, 255, 255, 0.2);
            border-color: rgba(255, 255, 255, 0.4);
          }
          .testimonial-swiper .swiper-pagination-bullet {
            background: rgba(255, 255, 255, 0.5);
          }
          .testimonial-swiper .swiper-pagination-bullet-active {
            background: white;
          }
        `}</style>
      </section>

      {/* ── TECHNOLOGY PARTNER ECOSYSTEM ── */}
      <section style={{ padding: '90px 0 0', background: '#f8fafc', overflow: 'hidden' }}>
        <div className="container">
          <div className="row align-items-start g-4 mb-5">
            <div className="col-lg-6">
              <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} viewport={{ once: true }}>
                <p style={{ color: '#2563eb', fontWeight: 700, letterSpacing: '2.5px', textTransform: 'uppercase', fontSize: '0.76rem', marginBottom: '14px' }}>ECOSYSTEM</p>
                <h2 style={{ color: '#0f172a', fontWeight: 800, fontSize: 'clamp(2rem, 3.5vw, 3rem)', lineHeight: 1.2, margin: 0 }}>
                  Our Technology<br />Partner Ecosystem
                </h2>
              </motion.div>
            </div>
            <div className="col-lg-6 d-flex align-items-end">
              <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.1 }} viewport={{ once: true }}
                style={{ color: '#64748b', fontSize: '1rem', lineHeight: 1.8, margin: 0, paddingBottom: '6px' }}>
                An integrated network of global and regional technology partners supporting every layer of enterprise IT — from infrastructure to security.
              </motion.p>
            </div>
          </div>
        </div>

        {/* ── Infinite Marquee Row 1 (left→right) ── */}
        <div style={{ position: 'relative', overflow: 'hidden', marginBottom: '20px' }}>
          <div style={{ display: 'flex', width: 'max-content', animation: 'marquee-left 35s linear infinite' }}>
            {[...allPartners, ...allPartners].map((p, i) => (
              <div key={i} style={{
                flexShrink: 0, margin: '0 12px',
                background: '#fff', borderRadius: '14px',
                border: '1.5px solid #e2e8f0',
                width: '160px', height: '90px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                padding: '14px 18px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.04)',
              }}>
                <img src={p.logo} alt={p.name}
                  style={{ maxWidth: '110px', maxHeight: '50px', objectFit: 'contain' }} />
              </div>
            ))}
          </div>
        </div>

        {/* ── Infinite Marquee Row 2 (right→left) ── */}
        <div style={{ position: 'relative', overflow: 'hidden', paddingBottom: '72px' }}>
          <div style={{ display: 'flex', width: 'max-content', animation: 'marquee-right 40s linear infinite' }}>
            {[...allPartners.slice().reverse(), ...allPartners.slice().reverse()].map((p, i) => (
              <div key={i} style={{
                flexShrink: 0, margin: '0 12px',
                background: '#fff', borderRadius: '14px',
                border: '1.5px solid #e2e8f0',
                width: '160px', height: '90px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                padding: '14px 18px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.04)',
              }}>
                <img src={p.logo} alt={p.name}
                  style={{ maxWidth: '110px', maxHeight: '50px', objectFit: 'contain' }} />
              </div>
            ))}
          </div>
        </div>

        <style>{`
                          @keyframes marquee-left {
                              0%   { transform: translateX(0); }
                              100% { transform: translateX(-50%); }
                          }
                          @keyframes marquee-right {
                              0%   { transform: translateX(-50%); }
                              100% { transform: translateX(0); }
                          }
                      `}</style>
      </section>

      {/* Modern Blog Section */}
      <section className="blog-section py-5" style={{ backgroundColor: '#0f0c29' }}>
        <div className="container">
          <div className="text-center mb-5">
            <span className="services-label">INSIGHTS & TRENDS</span>
            <h2 className="services-main-heading">
              Latest From Our Blog
            </h2>
            <p className="services-subtitle ">
              Stay updated with the latest technology trends, insights, and best practices
            </p>
          </div>

          <div className="row g-4">
            {/* Blog 1 */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100 overflow-hidden" style={{ backgroundColor: '#1d1a3c', border: '1px solid #2d2a4c', borderRadius: '8px' }}>
                <img
                  src="https://www.q3tech.com/wp-content/uploads/2025/11/Intranet-Site-Using-SharePoint.jpg"
                  alt="Gaganyaan Mission"
                  className="card-img-top"
                  style={{ height: '220px', objectFit: 'cover' }}
                />
                <div className="card-body p-4 d-flex flex-column text-start">
                  <span className="fw-medium mb-3 d-block" style={{ fontSize: '0.9rem', color: '#b3b0c4' }}>Press Releases</span>
                  <h4 className="card-title fw-semibold mb-4 text-white" style={{ fontSize: '1.1rem', lineHeight: '1.5' }}>
                    ISRO awards Gaganyaan Mission mandate to deliver Crew Module Recovery Models (CMRM)
                  </h4>
                  <div className="mt-auto w-100 text-end">
                    <Link to="/blogs" className="fw-semibold text-decoration-none" style={{ fontSize: '0.85rem', color: '#fff', letterSpacing: '0.5px' }}>
                      READ MORE
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Blog 2 */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100 overflow-hidden" style={{ backgroundColor: '#1d1a3c', border: '1px solid #2d2a4c', borderRadius: '8px' }}>
                <img
                  src="https://www.q3tech.com/wp-content/uploads/2025/11/AI-Agent-Use-Cases.jpg"
                  alt="Nidec MOU"
                  className="card-img-top"
                  style={{ height: '220px', objectFit: 'cover' }}
                />
                <div className="card-body p-4 d-flex flex-column text-start">
                  <span className="fw-medium mb-3 d-block" style={{ fontSize: '0.9rem', color: '#b3b0c4' }}>Press Releases</span>
                  <h4 className="card-title fw-semibold mb-4 text-white" style={{ fontSize: '1.1rem', lineHeight: '1.5' }}>
                    Nidec Executes a Comprehensive MOU with our technology division.
                  </h4>
                  <div className="mt-auto w-100 text-end">
                    <Link to="/blogs" className="fw-semibold text-decoration-none" style={{ fontSize: '0.85rem', color: '#fff', letterSpacing: '0.5px' }}>
                      READ MORE
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* Blog 3 */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100 overflow-hidden" style={{ backgroundColor: '#1d1a3c', border: '1px solid #2d2a4c', borderRadius: '8px' }}>
                <img
                  src="https://www.q3tech.com/wp-content/uploads/2025/11/SharePoint-Corporate-Intranet-Portal.jpg"
                  alt="Healthcare Innovation"
                  className="card-img-top"
                  style={{ height: '220px', objectFit: 'cover' }}
                />
                <div className="card-body p-4 d-flex flex-column text-start">
                  <span className="fw-medium mb-3 d-block" style={{ fontSize: '0.9rem', color: '#b3b0c4' }}>Press Releases</span>
                  <h4 className="card-title fw-semibold mb-4 text-white" style={{ fontSize: '1.1rem', lineHeight: '1.5' }}>
                    Partnering to Advance Surgical Imaging and Healthcare Innovation
                  </h4>
                  <div className="mt-auto w-100 text-end">
                    <Link to="/blogs" className="fw-semibold text-decoration-none" style={{ fontSize: '0.85rem', color: '#fff', letterSpacing: '0.5px' }}>
                      READ MORE
                    </Link>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className="faq-section py-5 position-relative" style={{ backgroundColor: '#0a0a0f' }}>
        {/* Subtle background gradients */}
        <div className="faq-bg-glow position-absolute" style={{ top: '-30%', right: '-10%', width: '600px', height: '600px', background: 'radial-gradient(circle, rgba(65,135,247,0.08) 0%, transparent 70%)', pointerEvents: 'none' }}></div>
        <div className="faq-bg-glow position-absolute" style={{ bottom: '-20%', left: '-5%', width: '400px', height: '400px', background: 'radial-gradient(circle, rgba(139,92,246,0.06) 0%, transparent 70%)', pointerEvents: 'none' }}></div>

        <div className="container py-md-5">
          {/* Header */}
          <motion.div
            className="mb-5"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="fw-bold mb-2" style={{ fontSize: 'clamp(2.2rem, 4vw, 3.2rem)', color: '#ffffff', letterSpacing: '-0.02em' }}>
              Frequently asked questions
            </h2>
            <p className="mb-0" style={{ color: 'rgba(255,255,255,0.5)', fontSize: '1.05rem' }}>
              Everything you need to know about our services and solutions
            </p>
          </motion.div>

          <div className="row g-5">
            {/* Left: FAQ Accordion */}
            <div className="col-lg-7">
              <div className="faq-list d-flex flex-column gap-3">

                {/* FAQ Item 1 */}
                <motion.div
                  className={`faq-item rounded-4 ${active === '1' ? 'active' : ''}`}
                  style={{ background: active === '1' ? 'rgba(30,30,50,0.9)' : 'rgba(20,20,35,0.7)', border: '1px solid rgba(255,255,255,0.06)', backdropFilter: 'blur(12px)', transition: 'all 0.3s ease', cursor: 'pointer' }}
                  onClick={() => setActive(active === '1' ? '' : '1')}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 0.05 }}
                  viewport={{ once: true }}
                  whileHover={{ borderColor: 'rgba(65,135,247,0.2)' }}
                >
                  <div className="d-flex align-items-center p-4">
                    <span className="faq-number d-flex align-items-center justify-content-center rounded-circle me-3 flex-shrink-0" style={{ width: '36px', height: '36px', background: 'rgba(65,135,247,0.12)', border: '1px solid rgba(65,135,247,0.2)', color: '#60a5fa', fontSize: '0.85rem', fontWeight: '700' }}>1</span>
                    <div className="flex-grow-1">
                      <h5 className="fw-semibold mb-0" style={{ color: '#ffffff', fontSize: '1.05rem' }}>What services does Solaris offer?</h5>
                    </div>
                    <div className="faq-icon ms-3 flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle" style={{ width: '28px', height: '28px', background: 'rgba(255,255,255,0.06)', transition: 'transform 0.3s ease', transform: active === '1' ? 'rotate(45deg)' : 'rotate(0deg)' }}>
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1V13M1 7H13" stroke="white" strokeWidth="2" strokeLinecap="round" /></svg>
                    </div>
                  </div>
                  <div className={`faq-answer px-4 pb-4 ${active === '1' ? 'd-block' : 'd-none'}`}>
                    <p className="mb-0" style={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.95rem', lineHeight: '1.7' }}>
                      We provide comprehensive IT solutions including Cyber Security, Data Center Solutions, Enterprise Networking, Managed Services, Professional Services, and Collaboration Services. Our expertise spans across infrastructure, security, and digital transformation.
                    </p>
                  </div>
                </motion.div>

                {/* FAQ Item 2 */}
                <motion.div
                  className={`faq-item rounded-4 ${active === '2' ? 'active' : ''}`}
                  style={{ background: active === '2' ? 'rgba(30,30,50,0.9)' : 'rgba(20,20,35,0.7)', border: '1px solid rgba(255,255,255,0.06)', backdropFilter: 'blur(12px)', transition: 'all 0.3s ease', cursor: 'pointer' }}
                  onClick={() => setActive(active === '2' ? '' : '2')}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 0.1 }}
                  viewport={{ once: true }}
                  whileHover={{ borderColor: 'rgba(65,135,247,0.2)' }}
                >
                  <div className="d-flex align-items-center p-4">
                    <span className="faq-number d-flex align-items-center justify-content-center rounded-circle me-3 flex-shrink-0" style={{ width: '36px', height: '36px', background: 'rgba(65,135,247,0.12)', border: '1px solid rgba(65,135,247,0.2)', color: '#60a5fa', fontSize: '0.85rem', fontWeight: '700' }}>2</span>
                    <div className="flex-grow-1">
                      <h5 className="fw-semibold mb-0" style={{ color: '#ffffff', fontSize: '1.05rem' }}>How does your cybersecurity approach work?</h5>
                    </div>
                    <div className="faq-icon ms-3 flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle" style={{ width: '28px', height: '28px', background: 'rgba(255,255,255,0.06)', transition: 'transform 0.3s ease', transform: active === '2' ? 'rotate(45deg)' : 'rotate(0deg)' }}>
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1V13M1 7H13" stroke="white" strokeWidth="2" strokeLinecap="round" /></svg>
                    </div>
                  </div>
                  <div className={`faq-answer px-4 pb-4 ${active === '2' ? 'd-block' : 'd-none'}`}>
                    <p className="mb-0" style={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.95rem', lineHeight: '1.7' }}>
                      Our cybersecurity framework follows a Zero Trust architecture with comprehensive SOC readiness, identity and access management, endpoint protection, and ransomware defense. We assess your current posture, design tailored security solutions, and provide 24/7 monitoring and incident response.
                    </p>
                  </div>
                </motion.div>

                {/* FAQ Item 3 */}
                <motion.div
                  className={`faq-item rounded-4 ${active === '3' ? 'active' : ''}`}
                  style={{ background: active === '3' ? 'rgba(30,30,50,0.9)' : 'rgba(20,20,35,0.7)', border: '1px solid rgba(255,255,255,0.06)', backdropFilter: 'blur(12px)', transition: 'all 0.3s ease', cursor: 'pointer' }}
                  onClick={() => setActive(active === '3' ? '' : '3')}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 0.15 }}
                  viewport={{ once: true }}
                  whileHover={{ borderColor: 'rgba(65,135,247,0.2)' }}
                >
                  <div className="d-flex align-items-center p-4">
                    <span className="faq-number d-flex align-items-center justify-content-center rounded-circle me-3 flex-shrink-0" style={{ width: '36px', height: '36px', background: 'rgba(65,135,247,0.12)', border: '1px solid rgba(65,135,247,0.2)', color: '#60a5fa', fontSize: '0.85rem', fontWeight: '700' }}>3</span>
                    <div className="flex-grow-1">
                      <h5 className="fw-semibold mb-0" style={{ color: '#ffffff', fontSize: '1.05rem' }}>What industries do you serve?</h5>
                    </div>
                    <div className="faq-icon ms-3 flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle" style={{ width: '28px', height: '28px', background: 'rgba(255,255,255,0.06)', transition: 'transform 0.3s ease', transform: active === '3' ? 'rotate(45deg)' : 'rotate(0deg)' }}>
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1V13M1 7H13" stroke="white" strokeWidth="2" strokeLinecap="round" /></svg>
                    </div>
                  </div>
                  <div className={`faq-answer px-4 pb-4 ${active === '3' ? 'd-block' : 'd-none'}`}>
                    <p className="mb-0" style={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.95rem', lineHeight: '1.7' }}>
                      We serve a diverse range of industries including finance and banking, healthcare, manufacturing, retail, technology, government, and education. Each solution is tailored to meet industry-specific compliance requirements and operational needs.
                    </p>
                  </div>
                </motion.div>

                {/* FAQ Item 4 */}
                <motion.div
                  className={`faq-item rounded-4 ${active === '4' ? 'active' : ''}`}
                  style={{ background: active === '4' ? 'rgba(30,30,50,0.9)' : 'rgba(20,20,35,0.7)', border: '1px solid rgba(255,255,255,0.06)', backdropFilter: 'blur(12px)', transition: 'all 0.3s ease', cursor: 'pointer' }}
                  onClick={() => setActive(active === '4' ? '' : '4')}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 0.2 }}
                  viewport={{ once: true }}
                  whileHover={{ borderColor: 'rgba(65,135,247,0.2)' }}
                >
                  <div className="d-flex align-items-center p-4">
                    <span className="faq-number d-flex align-items-center justify-content-center rounded-circle me-3 flex-shrink-0" style={{ width: '36px', height: '36px', background: 'rgba(65,135,247,0.12)', border: '1px solid rgba(65,135,247,0.2)', color: '#60a5fa', fontSize: '0.85rem', fontWeight: '700' }}>4</span>
                    <div className="flex-grow-1">
                      <h5 className="fw-semibold mb-0" style={{ color: '#ffffff', fontSize: '1.05rem' }}>What is your typical project engagement model?</h5>
                    </div>
                    <div className="faq-icon ms-3 flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle" style={{ width: '28px', height: '28px', background: 'rgba(255,255,255,0.06)', transition: 'transform 0.3s ease', transform: active === '4' ? 'rotate(45deg)' : 'rotate(0deg)' }}>
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1V13M1 7H13" stroke="white" strokeWidth="2" strokeLinecap="round" /></svg>
                    </div>
                  </div>
                  <div className={`faq-answer px-4 pb-4 ${active === '4' ? 'd-block' : 'd-none'}`}>
                    <p className="mb-0" style={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.95rem', lineHeight: '1.7' }}>
                      We offer flexible engagement models including fixed-price projects, time and material, dedicated teams, and managed services retainers. We begin with a discovery phase, followed by architecture design, implementation, testing, deployment, and ongoing support.
                    </p>
                  </div>
                </motion.div>

                {/* FAQ Item 5 */}
                <motion.div
                  className={`faq-item rounded-4 ${active === '5' ? 'active' : ''}`}
                  style={{ background: active === '5' ? 'rgba(30,30,50,0.9)' : 'rgba(20,20,35,0.7)', border: '1px solid rgba(255,255,255,0.06)', backdropFilter: 'blur(12px)', transition: 'all 0.3s ease', cursor: 'pointer' }}
                  onClick={() => setActive(active === '5' ? '' : '5')}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 0.25 }}
                  viewport={{ once: true }}
                  whileHover={{ borderColor: 'rgba(65,135,247,0.2)' }}
                >
                  <div className="d-flex align-items-center p-4">
                    <span className="faq-number d-flex align-items-center justify-content-center rounded-circle me-3 flex-shrink-0" style={{ width: '36px', height: '36px', background: 'rgba(65,135,247,0.12)', border: '1px solid rgba(65,135,247,0.2)', color: '#60a5fa', fontSize: '0.85rem', fontWeight: '700' }}>5</span>
                    <div className="flex-grow-1">
                      <h5 className="fw-semibold mb-0" style={{ color: '#ffffff', fontSize: '1.05rem' }}>How do you ensure data security and compliance?</h5>
                    </div>
                    <div className="faq-icon ms-3 flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle" style={{ width: '28px', height: '28px', background: 'rgba(255,255,255,0.06)', transition: 'transform 0.3s ease', transform: active === '5' ? 'rotate(45deg)' : 'rotate(0deg)' }}>
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1V13M1 7H13" stroke="white" strokeWidth="2" strokeLinecap="round" /></svg>
                    </div>
                  </div>
                  <div className={`faq-answer px-4 pb-4 ${active === '5' ? 'd-block' : 'd-none'}`}>
                    <p className="mb-0" style={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.95rem', lineHeight: '1.7' }}>
                      We adhere to industry-leading security standards including ISO 27001, SOC 2, GDPR, and HIPAA compliance frameworks. Our data centers are Tier III certified with redundant infrastructure, encryption at rest and in transit, and regular security audits.
                    </p>
                  </div>
                </motion.div>

                {/* FAQ Item 6 */}
                <motion.div
                  className={`faq-item rounded-4 ${active === '6' ? 'active' : ''}`}
                  style={{ background: active === '6' ? 'rgba(30,30,50,0.9)' : 'rgba(20,20,35,0.7)', border: '1px solid rgba(255,255,255,0.06)', backdropFilter: 'blur(12px)', transition: 'all 0.3s ease', cursor: 'pointer' }}
                  onClick={() => setActive(active === '6' ? '' : '6')}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 0.3 }}
                  viewport={{ once: true }}
                  whileHover={{ borderColor: 'rgba(65,135,247,0.2)' }}
                >
                  <div className="d-flex align-items-center p-4">
                    <span className="faq-number d-flex align-items-center justify-content-center rounded-circle me-3 flex-shrink-0" style={{ width: '36px', height: '36px', background: 'rgba(65,135,247,0.12)', border: '1px solid rgba(65,135,247,0.2)', color: '#60a5fa', fontSize: '0.85rem', fontWeight: '700' }}>6</span>
                    <div className="flex-grow-1">
                      <h5 className="fw-semibold mb-0" style={{ color: '#ffffff', fontSize: '1.05rem' }}>What makes Solaris different from competitors?</h5>
                    </div>
                    <div className="faq-icon ms-3 flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle" style={{ width: '28px', height: '28px', background: 'rgba(255,255,255,0.06)', transition: 'transform 0.3s ease', transform: active === '6' ? 'rotate(45deg)' : 'rotate(0deg)' }}>
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1V13M1 7H13" stroke="white" strokeWidth="2" strokeLinecap="round" /></svg>
                    </div>
                  </div>
                  <div className={`faq-answer px-4 pb-4 ${active === '6' ? 'd-block' : 'd-none'}`}>
                    <p className="mb-0" style={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.95rem', lineHeight: '1.7' }}>
                      We combine deep technical expertise with a client-first approach. Our differentiators include 9+ years of experience, 1600+ successful projects, dedicated 24/7 support, flexible engagement models, and a team of certified professionals across cybersecurity, cloud, networking, and infrastructure domains.
                    </p>
                  </div>
                </motion.div>

              </div>
            </div>

            {/* Right: CTA Feature Card */}
            <div className="col-lg-5">
              <motion.div
                className="faq-cta-card rounded-4 overflow-hidden position-relative h-100 d-flex flex-column"
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
                style={{ minHeight: '500px', background: 'linear-gradient(135deg, #1e3a8a 0%, #4f46e5 40%, #7c3aed 100%)' }}
              >
                {/* Abstract glass shapes */}
                <div className="position-absolute" style={{ top: '-40px', right: '-30px', width: '200px', height: '200px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,255,255,0.12) 0%, transparent 70%)', filter: 'blur(30px)' }}></div>
                <div className="position-absolute" style={{ top: '20%', left: '-20%', width: '150px', height: '150px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%)', filter: 'blur(40px)' }}></div>
                <div className="position-absolute" style={{ bottom: '10%', right: '10%', width: '250px', height: '250px', borderRadius: '50%', background: 'radial-gradient(circle, rgba(167,139,250,0.1) 0%, transparent 70%)', filter: 'blur(50px)' }}></div>

                {/* Metallic glass floating orbs */}
                <div className="position-absolute rounded-circle" style={{ top: '50px', right: '40px', width: '60px', height: '60px', background: 'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.3), rgba(255,255,255,0.05))', border: '1px solid rgba(255,255,255,0.15)', backdropFilter: 'blur(4px)', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}></div>
                <div className="position-absolute rounded-circle" style={{ top: '120px', left: '30px', width: '40px', height: '40px', background: 'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.25), rgba(255,255,255,0.03))', border: '1px solid rgba(255,255,255,0.1)', backdropFilter: 'blur(4px)', boxShadow: '0 8px 32px rgba(0,0,0,0.15)' }}></div>
                <div className="position-absolute rounded-circle" style={{ bottom: '180px', right: '60px', width: '35px', height: '35px', background: 'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.2), rgba(255,255,255,0.02))', border: '1px solid rgba(255,255,255,0.08)', backdropFilter: 'blur(4px)' }}></div>
                <div className="position-absolute" style={{ top: '200px', right: '80px', width: '80px', height: '80px', borderRadius: '20px', background: 'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.15), rgba(255,255,255,0.02))', border: '1px solid rgba(255,255,255,0.1)', backdropFilter: 'blur(4px)', transform: 'rotate(15deg)' }}></div>
                <div className="position-absolute" style={{ bottom: '100px', left: '20px', width: '50px', height: '50px', borderRadius: '12px', background: 'radial-gradient(circle at 30% 30%, rgba(167,139,250,0.2), rgba(167,139,250,0.02))', border: '1px solid rgba(255,255,255,0.08)', backdropFilter: 'blur(4px)', transform: 'rotate(-10deg)' }}></div>

                {/* Content */}
                <div className="position-relative z-1 d-flex flex-column h-100 p-5 justify-content-center">
                  <div className="cta-content text-center">
                    <div className="mb-4 d-flex justify-content-center">
                      <div className="d-flex align-items-center justify-content-center rounded-circle" style={{ width: '72px', height: '72px', background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.15)', backdropFilter: 'blur(8px)' }}>
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                        </svg>
                      </div>
                    </div>

                    <h3 className="fw-bold text-white mb-3" style={{ fontSize: 'clamp(1.5rem, 2.5vw, 2rem)', lineHeight: '1.3' }}>
                      Didn't Find What You<br />Were Looking For?
                    </h3>
                    <p className="text-white mb-4 mx-auto" style={{ opacity: 0.7, fontSize: '0.95rem', lineHeight: '1.7', maxWidth: '340px' }}>
                      Our team of experts is ready to help you with any questions or custom requirements you may have.
                    </p>

                    <Link to="/contact" className="d-inline-flex text-decoration-none">
                      <motion.div
                        className="d-inline-flex align-items-center gap-2 rounded-pill px-4 py-3 fw-semibold"
                        style={{ background: '#ffffff', color: '#1e3a8a', fontSize: '0.95rem', transition: 'all 0.3s ease' }}
                        whileHover={{ scale: 1.05, boxShadow: '0 12px 40px rgba(0,0,0,0.3)' }}
                        whileTap={{ scale: 0.98 }}
                      >
                        Get In Touch With Our Experts
                        <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                          <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="#1e3a8a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </motion.div>
                    </Link>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>


      <ContactSection />

      {/* FAQ Section */}

    </>
  );
};

export default Home;
